import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../environments/environment';

export interface Note {
  id: number;
  projectId: number;
  date: Date;
  author: string;
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private apiUrl = environment.apiUrl +'notes';// Replace with your API endpoint

  constructor(private http: HttpClient) {}

  // Get all notes for a specific project
  getNotes(projectId: number): Observable<Note[]> {
    return this.http.get<Note[]>(`${this.apiUrl}?projectId=${projectId}`).pipe(
      catchError(this.handleError)
    );
  }

 // Get a single note by ID
  getNote(id: number): Observable<Note> {
    return this.http.get<Note>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }


  // Create a new note
  createNote(note: Note): Observable<Note> {
    return this.http.post<Note>(this.apiUrl, note).pipe(
      catchError(this.handleError)
    );
  }

  // Update an existing note
  updateNote(id: number, note: Note): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, note).pipe(
      catchError(this.handleError)
    );
  }

  // Delete a note
  deleteNote(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  // Error handling
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}